import { MessageSquare, ThumbsUp, UserPlus } from "react-feather";

export const SocialNavData = [
  {
    id: 1,
    tittle: "Timeline",
  },
  {
    id: 2,
    tittle: "About",
  },
  {
    id: 5,
    userProfile: true,
  },
  {
    id: 3,
    tittle: "Friends",
  },
  {
    id: 4,
    tittle: "Photos",
  },
];

export const UserProfileIconData = [
  {color:"primary",icon:"smile-o"},
  {color:"secondary",icon:"wechat"},
  {color:"warning",icon:"share-alt"},
]

export const SocialGroupData = [
  {
    imageName: "3.jpg",
    userName: "Johny Waston",
  },
  {
    imageName: "5.jpg",
    userName: "Andew Jon",
  },
  {
    imageName: "1.jpg",
    userName: "Comeren Diaz",
  },
  {
    imageName: "2.png",
    userName: "Bucky Barnes",
  },
  {
    imageName: "8.jpg",
    userName: "Jason Borne",
  },
  {
    imageName: "11.png",
    userName: "Comeren Diaz",
  },
];

export const MutualFriendList = [
  {
    id: 1,
    imageName: "2.png",
    title: "Bucky Barnes",
    email: "winter@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 2,
    imageName: "10.jpg",
    title: "Sarah Loren",
    email: "barnes@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 3,
    imageName: "6.jpg",
    title: "Jason Borne",
    email: "jasonb@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 4,
    imageName: "8.jpg",
    title: "Comeren Diaz",
    email: "comere@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 5,
    imageName: "14.png",
    title: "Andew Jon",
    email: "andrewj@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 6,
    imageName: "4.jpg",
    title: "Johny Waston",
    email: "johny@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 7,
    imageName: "3.jpg",
    title: "Johny William",
    email: "johnyw@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 8,
    imageName: "2.png",
    title: "Bucky Barnes",
    email: "winter@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 9,
    imageName: "10.jpg",
    title: "Sarah Loren",
    email: "barnes@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 10,
    imageName: "6.jpg",
    title: "Jason Borne",
    email: "jasonb@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 11,
    imageName: "8.jpg",
    title: "Comeren Diaz",
    email: "comere@gmail.com",
    socialClass: "social-offline",
  },
  {
    id: 12,
    imageName: "14.png",
    title: "Andew Jon",
    email: "andrewj@gmail.com",
    socialClass: "social-online",
  },
  {
    id: 13,
    imageName: "4.jpg",
    title: "Johny Waston",
    email: "johny@gmail.com",
    socialClass: "social-busy",
  },
  {
    id: 14,
    imageName: "3.jpg",
    title: "Johny William",
    email: "johnyw@gmail.com",
    socialClass: "social-offline",
  },
];

export const FriendData = [
  {
    time: "20 min",
    imageName: "10.jpg",
    title: "Andew Jon",
  },
  {
    time: "1 hour ",
    imageName: "3.jpg",
    title: "Johny Waston",
  },
  {
    time: "1 days",
    imageName: "5.jpg",
    title: "Comeren Diaz",
  },
  {
    time: "2 days",
    imageName: "4.jpg",
    title: "Sarah Loren",
  },
  {
    time: "5 days",
    imageName: "3.jpg",
    title: "Johny Waston",
  },
  {
    time: "6 days",
    imageName: "5.jpg",
    title: "Comeren Diaz",
  },
];

export const ProfileIntroData = [
  {
    title: "About Me",
    paragraph: "Hi, I’m elana, I’m 30 and I work as a web Designer for the “Daydreams”  Agency in Pier 56.",
  },
  {
    title: "Favourite TV Shows",
    paragraph: "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
  {
    title: "Favourite Music Bands",
    paragraph: "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
];

export const FollowerData = [
  {
    id: 1,
    imageName: "2.png",
    name: "Bucky Barnes",
  },
  {
    id: 2,
    imageName: "3.png",
    name: "Sarah Loren",
  },
  {
    id: 3,
    imageName: "3.jpg",
    name: "Jason Borne",
  },
  {
    id: 4,
    imageName: "10.jpg",
    name: "Comeren Diaz",
  },
  {
    id: 5,
    imageName: "11.png",
    name: "Andew Jon",
  },
];

export const FollowingData = [
  {
    id: 1,
    imageName: "3.png",
    name: "Sarah Loren",
  },
  {
    id: 2,
    imageName: "2.png",
    name: "Bucky Barnes",
  },
  {
    id: 3,
    imageName: "10.jpg",
    name: "Comeren Diaz",
  },
  {
    id: 4,
    imageName: "3.jpg",
    name: "Jason Borne",
  },
  {
    id: 5,
    imageName: "11.png",
    name: "Andew Jon",
  },
];

export const FriendsImages = ["3.jpg", "5.jpg", "1.jpg", "2.png", "3.png", "6.jpg", "10.jpg", "14.png", "1.jpg", "4.jpg", "11.png", "8.jpg"];

export const PeopleKnowData = [
  {
    peopleName: "Jason Borne",
    peopleImageName: "user/2.png",
  },
  {
    peopleName: "Anna Mull",
    peopleImageName: "user/3.png",
  },
  {
    peopleName: "Dion Cast",
    peopleImageName: "user/3.jpg",
  },
  {
    peopleName: "Karlene Lex",
    peopleImageName: "user/4.jpg",
  },
  {
    peopleName: "Vella Chism",
    peopleImageName: "user/8.jpg",
  },
  {
    peopleName: "Wai Schalk",
    peopleImageName: "user/10.jpg",
  },
  {
    peopleName: "Karlene Lex",
    peopleImageName: "user/14.png",
  },
];

export const HobbiesData = [
  {
    heading1: "Hobbies:",
    heading2: "Favourite Music Bands / Artists:",
    paragraph1: "I like to ride the bike to work, swimming, and working out. I also like reading design magazines, go to museums, and binge watching a good tv show while it’s raining outside.",
    paragraph2: "Iron Maid, DC/AC, Megablow, The Ill, Kung Fighters, System of a Revenge.",
  },
  {
    heading1: "Favourite TV Shows:",
    heading2: "Favourite Books:",
    paragraph1: "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
    paragraph2: "The Crime of the Century, Egiptian Mythology 101, The Scarred Wizard, Lord of the Wings, Amongst Gods, The Oracle, A Tale of Air and Water.",
  },
  {
    heading1: "Favourite Movies:",
    heading2: "Favourite Writers:",
    paragraph1: "Idiocratic, The Scarred Wizard and the Fire Crown, Crime Squad Ferrum Man.",
    paragraph2: "Martin T. Georgeston, Jhonathan R. Token, Ivana Rowle, Alexandr Platt, Marcus Roth.",
  },
  {
    heading1: "Favourite Games:",
    heading2: "Other Interests:",
    paragraph1: "The First of Us, Assassin’s Squad, Dark Assylum, NMAK16, Last Cause 4, Grand Snatch Auto.",
    paragraph2: "Swimming, Surfing, Scuba Diving, Anime, Photography, Tattoos, Street Art.",
  },
];

export const EducationData = [
  {
    heading1: "The New College of Design",
    heading2: "Digital Design Intern",
    date1: "2001-2006",
    date2: "2006-2008",
    paragraph1: "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
    paragraph2: "Digital Design Intern for the “Multimedz” agency. Was in charge of the communication with the clients.",
  },
  {
    date1: "2008",
    date2: "2001-2006",
    heading1: "Rembrandt Institute",
    heading2: "UI/UX Designer",
    paragraph1: "Five months Digital Illustration course. Professor: Leonardo Stagg.",
    paragraph2: "Breaking Good, RedDevil, People of Interest, The Running Dead, Found, American Guy.",
  },
  {
    date1: "2010",
    date2: "2008-2013",
    heading1: "The Digital College",
    heading2: "The New College of Design",
    paragraph1: "6 months intensive Motion Graphics course. After Effects and Premire. Professor: Donatello Urtle.",
    paragraph2: "UI/UX Designer for the “Daydreams” agency.",
  },
];

export const ActivityLogData = [
  {
    id: 1,
    icon: <ThumbsUp className="m-r-20" />,
    description: "Comeren Diaz likes your photos.",
  },
  {
    id: 2,
    icon: <UserPlus className="m-r-20" />,
    description: "Karlene Lex and Comeren Diaz now friends.",
  },
  {
    id: 3,
    icon: <MessageSquare className="m-r-20" />,
    description: "Sarah Loren wrote on your timeline",
  },
  {
    id: 4,
    icon: <ThumbsUp className="m-r-20" />,
    description: `Johny Waston likes your post's.`,
  },
  {
    id: 5,
    icon: <UserPlus className="m-r-20" />,
    description: "Andew Jon became friends with Comeren Diaz.",
  },
  {
    id: 6,
    icon: <UserPlus className="m-r-20" />,
    description: "Johny Waston became friends with Bucky Barnes.",
  },
];

export const SocialChatData = [
  { class: "your-msg", image: "1.jpg", title: "Jason Borne", year: "1 Year Ago", text: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post" },
  { class: "other-msg", image: "2.png", title: "Alexendra Dhadio", year: "1 Month Ago", text: "yes, really very awesome car i see the features of this car in the official website of #Mercedes-Benz and really impressed :-)" },
  { class: "other-msg", image: "3.png", title: "Olivia Jon", year: "15 Days Ago", text: "i like lexus cars, lexus cars are most beautiful with the awesome features, but this car is really outstanding than lexus" },
  { class: "your-msg", image: "1.jpg", title: "Issa Bell", year: "1 Year Ago", text: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post" },
];

export const SocialChatsData = [
  { class: "your-msg", image: "1.jpg", title: "Jason Borne", year: "1 Year Ago", text: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post" },
  { class: "your-msg", image: "1.jpg", title: "Issa Bell", year: "1 Year Ago", text: "we are working for the dance and sing songs. this car is very awesome for the youngster. please vote this car and like our post" },
];
